import { withInstall } from '@sgui-plus/utils/with-install'
import Result from './src/result.vue'

export const SgResult = withInstall(Result)

export default SgResult

export * from './src/result'
